import { render, staticRenderFns } from "./IncomeDocumentsPage.vue?vue&type=template&id=ce2d308c&scoped=true"
import script from "./IncomeDocumentsPage.vue?vue&type=script&lang=js"
export * from "./IncomeDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2d308c",
  null
  
)

export default component.exports